import React, {Component} from 'react'
import DatePicker from 'react-datepicker'
import AdSense from 'react-adsense';
import "react-datepicker/dist/react-datepicker.css";
import './App.css';

class App extends Component {
  constructor(props) {
      super(props)

      this.state = {
        startDate: new Date(),
        hide: true,
        twoDosesVaccines: false,
        ratNegative: false,
        tnc: false,
        refShow: false
      }
  }

  getAddDate = (days) =>{
    let leaveDate = new Date(this.state.startDate.getTime());
    leaveDate.setDate(leaveDate.getDate() + days);
    return leaveDate.getDate()+'/'+(leaveDate.getMonth()+1)+"/"+leaveDate.getFullYear();
  }

  render() {

    return (
      <div className="App">
        <header className="App-header">
          <h1>
          確診COVID-19後隔離日數計算機(只適用於香港)<br/>Calculator for the number of the quarantine days after diagnosis of COVID-19<br/>(Applicable to the Hong Kong)
          </h1>
        </header>
        <div className="adContact">
          <a href="https://wa.me/85284810388" target="_blank" rel="noreferrer">
            <img src="./Civicle_ad_banner_s.png" alt="提供網頁寄存及網頁設計，包括：公司網頁，企業管理系統，廣告或活動網頁等等。" />
          </a>
        </div>
        <table>
          <tbody>
          <tr>
            <th width="50%">
              <label htmlFor="diagnosisDate">第一日<br/>Day 1<br/>(dd/mm/yyyy)</label>
            </th>
            <td>
              <DatePicker id="diagnosisDate" dateFormat="dd/MM/yyyy" selected={this.state.startDate} onChange={(date) => this.setState({startDate: date, leaveDate: new Date(date.getDate()+14)})} /><span className="info" onClick={()=>this.setState({"hide": !this.state.hide})}>i</span>
            </td>
          </tr>
          <tr className={this.state.hide?"hideDayOne":""}>
            <td colSpan="2">
            <div className="closeBtn" onClick={()=>this.setState({"hide": true})}>x</div>
              <p>接受檢測或接收樣本翌日；如無接受檢測或接收樣本紀錄，填寫收到檢測結果通知當日。<br/>
              The day following testing or collection of sample; if there is no such testing or collection record, fill in the day on receiving the test result.</p>
            </td>
          </tr>
          <tr>
            <th>
              <label htmlFor="twoDosesVaccines">已接種2針COVID-19疫苗<br/>Received at least two doses of COVID-19 vaccines</label>
            </th>
            <td>
            <input id="twoDosesVaccines" type="checkbox" checked={this.state.twoDosesVaccines} onChange={()=> this.setState({twoDosesVaccines: !this.state.twoDosesVaccines})} />
            </td>
          </tr>
          {this.state.twoDosesVaccines?
            <>
              <tr>
                <th>第6天快速抗原測試 (由第二日起計)<br/>Rapid Antigen Tests on Day 6 (Count from Day 2)</th>
                <td><span className="ratDate">{this.getAddDate(6)}</span></td>
              </tr>
              <tr>
                <th>第7天快速抗原測試 (由第二日起計)<br/>Rapid Antigen Tests on Day 7 (Count from Day 2)</th>
                <td><span className="ratDate">{this.getAddDate(7)}</span></td>
              </tr>
              <tr>
                <td colSpan="2">
                  <p className="pointer" onClick={()=>this.setState({refShow: true})}>
                    可參考保安局局長鄧炳強的家居檢疫日數<br/>
                    Reference: The number of days for the home quarantine(from Mr Tang Ping-keung, the Secretary for Security)
                  </p>
                  {this.state.refShow?
                    <p>
                      2022年2月23日(第一日) ：開始居家檢疫<br/>
                      2022年3月1日(第六天)：進行快速抗原測試<br/>
                      2022年3月2日(第七天)：進行快速抗原測試<br/>
                      2022年3月2日(第七天)：結束家居檢疫並已返回辦公室工作<br/>
                      <br/>
                      February 23, 2022 (Day 1): Start home quarantine<br/>
                      March 1, 2022 (Day 6): Rapid Antigen Tests (RAT)<br/>
                      March 2, 2022 (Day 7): Rapid Antigen Tests (RAT)<br/>
                      March 2, 2022 (Day 7): Completed his home quarantine and returned to office for work today<br/>
                      <br/>
                      <a href="https://www.info.gov.hk/gia/general/202203/02/P2022030200157.htm" rel="noreferrer" target="_blank">新聞 News</a>
                    </p>
                    :''
                    }
                </td>
              </tr>
              <tr>
                <th><label htmlFor="ratNegative">連續兩天的快速抗原測試均取得陰性測試結果<br/>The RATs on these two successive days were negative</label></th>
                <td><input id="ratNegative" type="checkbox" checked={this.state.ratNegative} onChange={()=> this.setState({ratNegative: !this.state.ratNegative})} /></td>
              </tr>
            </>
            :''
          }
          <tr>
            <th>完成隔離日 (可離開隔離地點)<br/>End of quarantine (Leave the place of quarantine)</th>
            <td><span className="leaveDate">{(this.state.twoDosesVaccines && this.state.ratNegative)?this.getAddDate(7):this.getAddDate(14)}</span>
            </td>
          </tr>
          </tbody>
        </table>
        <AdSense.Google
          client='ca-pub-8121492846446442'
          slot='9409151813'
          style={{ display: 'block' }}
          format='auto'
          responsive='true'
          layoutKey='-gw-1+2a-9x+5c'
        />
        <div className="ps">
          <p>利申: 隔離日數計算方法是根據<a href="https://www.info.gov.hk/gia/general/202202/26/P2022022600622.htm" target="_blank" rel="noreferrer">政府和醫管局決定</a>，但由於政府政策朝令夕改，若發現計算方法有誤，請通知：<a href="mailto:info@senju-banno.com">info@senju-banno.com</a>，謝謝。<br/>
          P.S.: The above calculation method is according to <a href="https://www.info.gov.hk/gia/general/202202/26/P2022022600750.htm" target="_blank" rel="noreferrer">the guideline provided by the government and HA(Hospital Authority)</a>. However, the number of days may difference between the result and official days due to the unexpected changes in government policies. Email to: <a href="mailto:info@senju-banno.com">info@senju-banno.com</a> if you find any problems, Many thanks.
          </p>
          <p>
          其餘在隔離時需進行的快速抗原測試日子，請以衞生防護中心派發給確診者及密切接觸者的小冊子為準。<br/>
          Except for the above days, the Rapid Antigen Test is required when Self-quarantine, and please follow the guideline for the confirmed patients and the close contacts provided by CHP(Centre for Health Protection).</p>
        
          <p className="pointer" onClick={()=>this.setState({tnc: true})}>
            <strong>隱私政策 &amp; 免責聲明  Privacy Policy &amp; Disclaimer</strong>
          </p>
          {this.state.tnc?
          <div>
            <p>
            本網頁不會記錄及收集閣下所輸入的一切資料。<br/>
            <br/>
            計算出之日數只供參考，若有疑問，請致電衛生防護中心或醫管局。<br/>
            <br/>
            對於本網頁所載任何資料的準確性及完整性，本公司一概拒絕承認任何隱含的及/或明示的保証，並且不會就此作出任何陳述。 對於因使用或依賴本網頁的資料或任何網頁上載錄或與網頁連線的任何東西，包括但不限於任何 錯誤、誤差、遺漏、或侵權性質、誹謗性質或虛假性質的信息或任何其他可導致冒犯或在其他方面引致發生任何追索或投訴的資料或遺漏，而導致之任何損失或損害，本公司概不承擔任何有關責任。
            </p>
            <p>
            We will not record or collect any pieces of information you enter.<br/>
            <br/>
            The calculated number of days is for reference only. If in doubt, please call the CHP(Centre for Health Protection) 
            or HA(Hospital Authority).<br/>
            <br/>
            Civicle System Limited disclaims all implied and/or express warranties and makes no representation as to the accuracy or completeness of any information on the site. We assume no liability for any loss or damages arising from the use or reliance of the information on the site or for anything posted on or linked to it, including without limitation any mistake, error, omission, infringement, defamation, falsehood, or other material or omission that might offend or otherwise give rise to any claim or complaint.
            </p>
          </div>
          :''
          }
        </div>
        <div id="lastReviewDate">
          最後更新日期 Last update date: 02/03/2022
        </div>
        <div id="footer">
          <a href="/">千手万能 SENJU-BANNO</a> @ Powered by <a href="mailto:info@civicle.com">Civicle System Limited</a>
        </div>
      </div>
    );
  }
}

export default App;
